import styled from 'styled-components'

export const HoleMenuItem = styled.a`
  white-space: nowrap;
  width: 100%;
`
